<template>
  <div class="journal-item-layout lh-copy">
    <div class="text-primary journal-item-time f6">
      <div>{{ formatDate() }}</div>
      <div>{{ timeAgo() }}</div>
    </div>
    <div class="text-primary">
      <div class="b">{{ item.eventName }}</div>
      <div class="" id="journal-item-company">{{ item.companyTitle }}</div>
    </div>
    <div class="text-primary">
      <div>{{ item.comment }}</div>
    </div>
  </div>
</template>

<script>
const moment = require('moment')

export default {
  props: ['item'],
  methods: {
    eventName () {
      // не используется поскольку имя события грузится вместе с самим событием...
      return this.$store.getters['dict/procedureEventType'](this.item.eventType).name
    },
    formatDate () {
      return moment(this.item.date).format('YYYY-MM-DD HH:mm')
    },
    timeAgo () {
      return moment(this.item.date).fromNow()
    }
  }
}
</script>

<style lang="scss" scoped>
.journal-item-layout {
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: auto;
  grid-column-gap: .25rem;
  grid-row-gap: 1rem;
}
@media screen and (min-width: 60em) {
  .journal-item-layout {
    display: grid;
    grid-template-columns: 150px 10fr 25fr;
    grid-template-rows: auto;
    grid-column-gap: .25rem;
    grid-row-gap: .25rem;
  }
}
.journal-item-time {
  margin-top: .1rem;
}
</style>
